import { FunctionComponent, ReactNode } from 'react';
import styled, { keyframes } from 'styled-components';

import Overlay, { OverlayProps } from '@/components/molecules/overlay';

interface BottomSheetProps extends Pick<OverlayProps, 'onClickOverlay'> {
  index?: number;
  isOpened: boolean;
  children: ReactNode;
}

const BottomActionSheet: FunctionComponent<BottomSheetProps> = ({
  index = 2,
  isOpened,
  children,
  onClickOverlay,
}: BottomSheetProps) => {
  return (
    <>
      {isOpened && (
        <BottomSheetActionOverlay index={index} onClickOverlay={onClickOverlay}>
          <BottomSheetActionContainer>{children}</BottomSheetActionContainer>
        </BottomSheetActionOverlay>
      )}
    </>
  );
};

export default BottomActionSheet;

export const BottomSheetActionOverlay = styled(Overlay)`
  align-items: flex-end;
`;

const BottomUp = keyframes`
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
`;

export const BottomSheetActionContainer = styled.div`
  background-color: white;
  bottom: 32px;
  padding: 24px 12px;
  position: absolute;
  width: calc(100% - 32px);
  max-width: 736px;
  border-radius: 20px;
  animation: ${BottomUp} 0.3s;
`;
